exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle {\n  color: #fff;\n  background: #FF9633;\n  font-size: 11px;\n  line-height: 11px;\n  padding: 3px 6px 3px 6px;\n  height: 20px;\n  border-radius: 50%;\n  -moz-border-radius: 50%;\n  -webkit-border-radius: 50%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/ui/notification-icon/notification-icon.component.scss
// module id = ../../../../../src/app/shared/ui/notification-icon/notification-icon.component.scss
// module chunks = 10